import _ = require("lodash");
import { TemplateUIExcelInterface } from "../template/TemplateUIExcelInterface";

export class TemplateTaskUIExcelInterface extends TemplateUIExcelInterface {
  // override other methods when required
  getMappedListData(data, configuration, engagementIdToRender): any {
    let response = data.response;
    if (data && data.response && data.response?.length) {
      let editableItems = data.response.filter((x) => x.isTaskNameEditable);
      let nonEditableItems = data.response.filter((x) => !x.isTaskNameEditable);
      let sortedEditableItems = editableItems.sort(function(a, b) {
        return a["taskDisplayName"].localeCompare(b["taskDisplayName"]);
      });
      let sortedNonEditableItems = nonEditableItems.sort(function(a, b) {
        return a["taskDisplayName"].localeCompare(b["taskDisplayName"]);
      });

      //let sortedEditableItems = _.sortBy(editableItems, ["taskDisplayName"]);
      //let sortedNonEditableItems = _.sortBy(nonEditableItems, ["taskDisplayName"]);
      data.response = [...sortedEditableItems, ...sortedNonEditableItems];
    }

    response = super.getMappedListData(data, configuration, engagementIdToRender);

    return response;
  }
}
